<template>
  <div class="menu dinline-block vtop fs14 pl35">
    <div class="tleft pl5 pr10 tc6 pb15">
      <div class="fs24 mr5 dinline-block prelative">
        <span class="img-schange img-bg dinline-block vbottom"></span>
        {{id>0?$params['enrollColumn'][pid]['children'][id]['name']:$params['enrollColumn'][pid]['name']}}
      </div>
      <div class="pt10 fr">
        当前位置:
        <span v-if="id>0">{{$params['enrollColumn'][pid]['name']}} > </span>
        <span>{{id>0?$params['enrollColumn'][pid]['children'][id]['name']:$params['enrollColumn'][pid]['name']}}</span>
      </div>
    </div>
    <div class="notices border-red tleft pt15 pl15 pr10 pb20 ncont tc6 fs16 lh20 border-red" v-html="info.content">
    </div>
  </div>
</template>

<script>
export default {
  name: "articleContent",
  data(){
    return {
      id:0,
      pid:0,
      perPage:1,
      page:1,
      info:{},
      msg:'加载中……',
    }
  },
  created() {
    this.updateData();
  },
  methods:{
    updateData(){
      this.id = this.$route.query.id
      this.pid = this.$route.query.pid
      this.getData();
    },
    getData(){
      var getParam = {}
      var id = this.$params.enrollColumn[this.pid]['params']['article_id'] || this.$params.enrollColumn[this.pid]['children'][this.id]['params']['article_id']
      getParam['id'] = id
      this.$request.get('recruit-article/detail',getParam,response => {
        if(response.status == 200){
          if(response.data.code != 200){
            this.msg = response.data.message;
            this.info = {};
          }else{
            let res = response.data.data
            this.info = res
          }
        }else{
          this.msg = '请求失败';
        }
      },error => {
        console.log(error)
      })
    },
  },
  watch:{
    $route:{
      deep:true,
      handler:function($n,$o){
        this.id = $n.query.id
        this.pid = $n.query.pid
        this.info = {};
        this.getData()
      }
    }
  },
}
</script>

<style scoped>
  .menu{width: 930px;margin-top:0;}
  .img-media{background: url(../../assets/images/scn1.png) no-repeat -60px -28px;}
  .img-sinfo{background: url(../../assets/images/scn1.png) no-repeat -60px -195px;}
  .img-schange{background: url(../../assets/images/scn1.png) no-repeat -60px -280px;}
  .img-splan{background: url(../../assets/images/scn1.png) no-repeat -60px -364px;}
  .img-splan{background: url(../../assets/images/scn1.png) no-repeat -60px -364px;}
  .img-sproblem{background: url(../../assets/images/scn1.png) no-repeat -60px -448px;}
  .img-sdown{background: url(../../assets/images/scn1.png) no-repeat -60px -528px;}
</style>



// WEBPACK FOOTER //
// src/pages/enroll/articleContent.vue